// src/utils/date.js
const tz = 'America/Sao_Paulo';

function parseYMD(s) {                 // "2025-10-03"
  const [y,m,d] = s.split('-').map(Number);
  return new Date(y, m-1, d);
}
function parseYMDHMS(s) {              // "2025-10-03 20:55:50"
  const [d, t='00:00:00'] = s.split(' ');
  const [y,m,day] = d.split('-').map(Number);
  const [hh,mm,ss] = t.split(':').map(Number);
  return new Date(y, m-1, day, hh||0, mm||0, ss||0);
}

export const toBRDate = (s) =>
  !s ? '-' : new Intl.DateTimeFormat('pt-BR',{ timeZone: tz }).format(parseYMD(s));

export const toBRDateTime = (s) =>
  !s ? '-' : new Intl.DateTimeFormat('pt-BR',{
    timeZone: tz, dateStyle: 'short', timeStyle: 'medium'
  }).format(parseYMDHMS(s));
